import { Demography } from "../../model"

// TODO: Supprimer la classe et exporter les méthodes individuellement.

export default class DemographyDomain {
	/**
	 * Retourne la demographie de l'année spécifiée en paramètre.
	 * @param demographies
	 * @param year
	 */
	static getDemography(demographies: Demography[], year): Demography|null {
		return demographies.find(demography => year === demography.year) || null
	}

	/**
	 * Retourne les démographies des années spécifiées en paramètres.
	 * @param demographies
	 * @param years
	 */
	static getDemographies(
		demographies: Demography[],
		years       : number[]
	): Array<Demography|null> {
		return years.map(year => DemographyDomain.getDemography(demographies, year))
	}
}

export function findByYear(
	demographies: Demography[],
	year: number
): Demography | null {
	return demographies.find(demography => year === demography.year) || null
}


// WEBPACK FOOTER //
// ./src/domain/sfp/demography-domain.ts